import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../utils";

export const vendorBookingList = createAsyncThunk('vendorBookingList', async ({ pageable: data, navigate, shop_id }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `booking`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'shop_id': shop_id
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const vendorBookingListSlice = createSlice({
    name: 'vendorBookingList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(vendorBookingList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(vendorBookingList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default vendorBookingListSlice.reducer;
